// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vCm-","col":"styles_col__2a96s"};